import oRingAxialB4Img from 'assets/images/oring/axial/O-Ring_axial_b4.png'
import oRingAxialD1Img from 'assets/images/oring/axial/O-Ring_axial_d1.png'
import oRingAxialD2Img from 'assets/images/oring/axial/O-Ring_axial_d2.png'
import oRingAxialD8Img from 'assets/images/oring/axial/O-Ring_axial_d8.png'
import oRingAxialGImg from 'assets/images/oring/axial/O-Ring_axial_g.png'
import oRingAxialHImg from 'assets/images/oring/axial/O-Ring_axial_h.png'
import oRingAxialR1Img from 'assets/images/oring/axial/O-Ring_axial_r1.png'
import oRingAxialDefaultImg from 'assets/images/oring/axial/O-Ring_axial_default.png'

import oRingRadialInBoreB1Img from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_b1.png'
import oRingRadialInBoreD1Img from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_d1.png'
import oRingRadialInBoreD2Img from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_d2.png'
import oRingRadialInBoreD5Img from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_d5.png'
import oRingRadialInBoreD6Img from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_d6.png'
import oRingRadialInBoreD10Img from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_d10.png'
import oRingRadialInBoreDefaultImg from 'assets/images/oring/radial-in-bore/O-Ring_radial-inBore_default.png'

import oRingRadialInShaftB1Img from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_b1.png'
import oRingRadialInShaftD1Img from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_d1.png'
import oRingRadialInShaftD2Img from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_d2.png'
import oRingRadialInShaftD3Img from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_d3.png'
import oRingRadialInShaftD4Img from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_d4.png'
import oRingRadialInShaftD9Img from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_d9.png'
import oRingRadialInShaftDefaultImg from 'assets/images/oring/radial-in-shaft/O-Ring_radial_inShaft_default.png'

export const useOringImageHelper = () => {
  const dimensionsImageMap = {
    axial: {
      b4: oRingAxialB4Img,
      d1: oRingAxialD1Img,
      d2: oRingAxialD2Img,
      d8: oRingAxialD8Img,
      gap: oRingAxialGImg,
      height: oRingAxialHImg,
      r1: oRingAxialR1Img,
      default: oRingAxialDefaultImg
    },
    radialInBore: {
      b1in: oRingRadialInBoreB1Img,
      d1: oRingRadialInBoreD1Img,
      d2: oRingRadialInBoreD2Img,
      d5: oRingRadialInBoreD5Img,
      d6: oRingRadialInBoreD6Img,
      d10: oRingRadialInBoreD10Img,
      default: oRingRadialInBoreDefaultImg
    },
    radialInShaft: {
      b1out: oRingRadialInShaftB1Img,
      d1: oRingRadialInShaftD1Img,
      d2: oRingRadialInShaftD2Img,
      d3: oRingRadialInShaftD3Img,
      d4: oRingRadialInShaftD4Img,
      d9: oRingRadialInShaftD9Img,
      default: oRingRadialInShaftDefaultImg
    }
  }

  const getImageForGeometryAndKey = (geometryId: number, key: string|null): string|null => {
    let group: Record<string, string> | undefined

    if (geometryId === 12) {
      group = dimensionsImageMap.axial
    } else if (geometryId === 8 || geometryId === 9) {
      group = geometryId === 9 ? dimensionsImageMap.radialInShaft : dimensionsImageMap.radialInBore
    }

    return group?.[key] || group?.default || null
  }

  return {dimensionsImageMap, getImageForGeometryAndKey}
}
